const calendarQuery = `
  query airPriceGuideCalendar($input: AirPriceGuideRequest) {
    airPriceGuide(input: $input) {
      error {
        type
        code
        message
      }
      
      records {
        dates
        minimumFare {
        isPrivateFare
        currency
        amtPerPax
        commonAttributes {
          takeOffTimes
          landingTimes
        }
        listOfStops {
          sliceId
          stops
        }
      }  
      }
      
    }
  }
`;
export { calendarQuery };
